import React, { useEffect, useState, useRef } from 'react';

const AnimatedElement = ({ children, className = 'scroll-fade-up', ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(); // Stop observing nach dem ersten Mal
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px'
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const finalClassName = isVisible ? `${className} animate` : className;

  return (
    <div ref={elementRef} className={finalClassName} {...props}>
      {children}
    </div>
  );
};

export default AnimatedElement;